import { Component } from '@angular/core';
import * as Highcharts from 'highcharts';
import { OrderServiceService } from 'src/app/services/orders/order-service.service';

@Component({
  selector: 'app-orders-by-status-chart',
  templateUrl: './orders-by-status-chart.component.html',
  styleUrls: ['./orders-by-status-chart.component.scss']
})
export class OrdersByStatusChartComponent {
  Highcharts: typeof Highcharts = Highcharts;
  statusData: any;
  colors: any = [
    { color: '#F7E3B1', status: 'Pendiente pago' },
    { color: '#ECB0B7', status: 'Cancelado' },
    { color: '#ABC2FF', status: 'En curso' },
    { color: '#CCDBBC', status: 'Entregado' },
  ]

  constructor(private orderService: OrderServiceService) { }

  ngOnInit() {
    this.getData();
  }

  async getData() {
    this.orderService.get_data_chart_orders_by_status().then((response: any) => {
      const percentage = response.total;
      const statusData: any = [];
      for (let data of response.data) {
        const colorData = this.colors.find((color) => color.status == data._id);
        statusData.push({
          total: data.count,
          percentage: (data.count * 100) / percentage,
          status: data._id,
          color: colorData.color
        });
      }
      this.statusData = statusData;
      this.printDataChart()
    });
  }

  printDataChart() {
    const chartLine = document.getElementById("chart-line");
    this.statusData.forEach(segment => {
      const div = document.createElement("div");
      div.classList.add("chart-segment");
      div.style.width = `${segment.percentage}%`;
      div.style.backgroundColor = segment.color;
      chartLine.appendChild(div);
    });
  }

}
